document.addEventListener("DOMContentLoaded", function () {
  const specsToggleButtons = document.querySelectorAll(".specs-toggle-btn")

  // Load saved preference from local storage, default to imperial.
  // Ignore anything that isn't a known unit — earlier versions could write "undefined".
  const storedUnit = localStorage.getItem("specs-unit-preference")
  const savedUnit = storedUnit === "metric" || storedUnit === "imperial" ? storedUnit : "imperial"

  specsToggleButtons.forEach(function (btn) {
    if (btn.dataset.unit === savedUnit) {
      btn.classList.add("active")
    } else {
      btn.classList.remove("active")
    }
  })

  if (savedUnit === "imperial") {
    document.body.classList.add("specs-imperial-active")
  }

  specsToggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const unit = this.dataset.unit

      // Save to local storage
      localStorage.setItem("specs-unit-preference", unit)

      // Remove active class from all buttons
      specsToggleButtons.forEach(function (btn) {
        btn.classList.remove("active")
      })

      // Add active class to clicked button
      this.classList.add("active")

      // Toggle body class for imperial/metric
      if (unit === "imperial") {
        document.body.classList.add("specs-imperial-active")
      } else {
        document.body.classList.remove("specs-imperial-active")
      }
    })
  })
})
